// Tutors join with an owner meeting token (POST /classroom-allocation/meeting-token), so
// Daily's `owner` flag identifies them without the child's browser needing any API call.
// The tutor email list (GET /users/tutors) stays as a fallback for a tutor who joined
// without a token. Children never hold owner tokens.
export function isTutorParticipant(participant, tutorEmails) {
  if (!participant) return false;
  if (participant.owner === true) return true;
  return Array.isArray(tutorEmails) && tutorEmails.includes(participant.user_name);
}
